import { 
  AppLayout,
  ContentLayout,
  SpaceBetween,
  Container,
  Grid,
  Header
} from "@cloudscape-design/components"

import Navigation from "./core-components/Navigation"
import CoreContent from "./core-components/CoreContent"
import CoreHeader from "./core-components/CoreHeader"
import CoreBreadcrumbs from "./core-components/CoreBreadcrumbs"
import CoreFooter from './core-components/CoreFooter'
/*import CoreRightPanel from './core-components/CoreRightPanel'*/

export default function App() {
  return (
    <>
      <div className="App">
          <ContentLayout
            header={
              <SpaceBetween size="xs">
                <Navigation></Navigation>
                <Container className='header-container'>
                  <CoreBreadcrumbs></CoreBreadcrumbs>

                  <CoreHeader></CoreHeader>
                </Container>
              </SpaceBetween>
            }
          >
          
            <CoreContent></CoreContent>
            
            {/* <div>
              <Container className='body-container'>
                <CoreContent></CoreContent>
              </Container>
            </div>
            <div>
              <Container className='body-container'>
                <Container className='drawer-container'>
                  <CoreRightPanel></CoreRightPanel>
                </Container>
              </Container>
            </div> */}
          
        </ContentLayout>
      </div>
      <CoreFooter></CoreFooter>
    </>
  )
}